export default __webpack_public_path__ + "static/media/va2017.669a944d.jpg";